module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "recover-password"
  }, [_c('div', {
    staticClass: "ls-login-parent"
  }, [_c('div', {
    staticClass: "ls-login-container"
  }, [_c('div', {
    staticClass: "ls-login-box"
  }, [_c('router-link', {
    staticClass: "ls-position-absolute",
    attrs: {
      "to": {
        name: 'auth'
      },
      "title": _vm.$t('login.signin')
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left ls-color-theme",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('h2', {
    staticClass: "ls-title-5 ls-txt-center ls-color-theme"
  }, [_vm._v(_vm._s(_vm.$t('login.forgot_your_password')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-txt-center"
  }, [_vm._v(_vm._s(_vm.$t('login.put_your_email')))]), _vm._v(" "), _c('form', {
    staticClass: "ls-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "ls-label",
    class: {
      'ls-error': _vm.errors.has(_vm.$t('login.mail'))
    }
  }, [_c('div', {
    staticClass: "ls-prefix-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "placeholder": _vm.$t('login.mail'),
      "name": _vm.$t('login.mail')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has(_vm.$t('login.mail'))),
      expression: "errors.has($t('login.mail'))"
    }],
    staticClass: "ls-help-message"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.$t('login.mail'))))])]), _vm._v(" "), _c('button', {
    staticClass: "ls-btn ls-btn-primary ls-btn-lg ls-full-width ls-md-margin-bottom"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_vm._v(_vm._s(_vm.$t('login.send_link_to_my_email')))]), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_vm._v(_vm._s(_vm.$t('login.sending_link_to_my_email')))])])]), _vm._v(" "), _c('p', {
    staticClass: "ls-txt-center"
  }, [_vm._v(_vm._s(_vm.$t('login.attributes.go_to_link')) + " "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'auth'
      },
      "title": _vm.$t('login.signin')
    }
  }, [_vm._v(_vm._s(_vm.$t('login.signin')))])], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "ls-login-logo"
  }, [_c('img', {
    attrs: {
      "src": require("./../../../assets/img/logo.svg"),
      "width": "140"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "ls-label-text-prefix"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb82c42c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/auth/RecoverPassword.vue
// module id = 827
// module chunks = 1